import React, { useEffect, useState } from "react";
import styles from "./Table.module.sass";
import Loader from "../../../components/Loader";
import Row from "./Row";
import Empty from "../../../components/Empty";
import { Pager } from "../../../components/Pager";
import Icon from "../../../components/Icon";
import Dropdown from "../../../components/Dropdown";
import { PageLimit } from "..";
import product from "../../../i11/Product";
import { useUser } from "../../../context";

const intervals = [
	"all",
	"upcoming",
	"ongoing",
	"closed",
	"minting",
	"minted",
	"hold_invoice",
];
const tokens = ["All Tokens", "PHYSICAL", "EXPERIENCE", "ART"];
const types = ["All", "Auction", "Standard"];

const typeVals = {
	All: [],
	Auction: ["AUCTION_EDITION"],
	Standard: ["SINGLE_EDITION", "LIMITED_EDITION"],
};

const Table = ({
	items,
	isLoading,
	open,
	set_edit,
	type,
	setFilter,
	filter,
	getNFTs_,
	setPage_,
	closeC,
	...rest
}) => {
	const { locale } = useUser();
	const [sorting, setSorting] = useState(intervals[0]);
	const [typeSort, setTypeSort] = useState(types[0]);
	const [sortingToken, setSortingToken] = useState(tokens[0]);

	useEffect(() => {
		setSorting(intervals[0]);
		setTypeSort(types[0]);
		setSortingToken(tokens[0]);
	}, [type]);

	const sort = (name) => {
		setFilter((p) => {
			return {
				...p,
				sortBy: name,
				orderBy:
					p.sortBy === name
						? p.orderBy === "asc"
							? "desc"
							: "asc"
						: "desc",
			};
		});
	};
	const ChangeType = (e) => {
		setTypeSort(e);
		if (e !== typeSort) {
			setPage_(1);
			setFilter((p) => {
				return {
					...p,
					offset: 0,
					limit: PageLimit,
					nftTypes: typeVals[e],
				};
			});
		}
	};
	const onChange = (e) => {
		setSorting(e);
		if (e !== sorting) {
			setPage_(1);
			setFilter((p) => {
				return {
					...p,
					offset: 0,
					limit: PageLimit,
					status: e.toUpperCase(),
				};
			});
		}
	};
	const onChangeToken = (value) => {
		setSortingToken(value);
		if (value !== sortingToken) {
			setPage_(1);
			setFilter((p) => {
				if (value === "All Tokens") {
					const tmp = { ...p };
					delete tmp["tokenType"];
					return tmp;
				}
				return {
					...p,
					offset: 0,
					limit: PageLimit,
					tokenType: value + "_TOKEN",
				};
			});
		}
	};
	return (
		<div className={styles.wrapper}>
			<div className={styles.table}>
				<div className={styles.row}>
					<div className={styles.col} onClick={() => sort("name")}>
						{product[locale].name}
						{filter.sortBy === "name" && (
							<Icon
								className={styles.icon_}
								name={
									filter.orderBy === "asc"
										? "arrow-top"
										: "arrow-bottom"
								}
								size="12"
							/>
						)}
					</div>
					<div className={styles.col}>
						{type === "Published" ? (
							<Dropdown
								className={styles.dropdown}
								classDropdownHead={styles.dropdownHead}
								value={sortingToken}
								setValue={onChangeToken}
								dictionary={product[locale].tokensDic}
								options={tokens}
								small
							/>
						) : (
							"Status"
						)}
					</div>
					<div className={styles.col} onClick={() => sort("price")}>
						{product[locale].price}
						{filter.sortBy === "price" && (
							<Icon
								className={styles.icon_}
								name={
									filter.orderBy === "asc"
										? "arrow-top"
										: "arrow-bottom"
								}
								size="12"
							/>
						)}
					</div>
					<div
						className={styles.col}
						onClick={() => sort("startDate")}
					>
						{product[locale].start_at}
						{filter.sortBy === "startDate" && (
							<Icon
								className={styles.icon_}
								name={
									filter.orderBy === "asc"
										? "arrow-top"
										: "arrow-bottom"
								}
								size="12"
							/>
						)}
					</div>
					<div className={styles.col} onClick={() => sort("endDate")}>
						{product[locale].end_at}
						{filter.sortBy === "endDate" && (
							<Icon
								className={styles.icon_}
								name={
									filter.orderBy === "asc"
										? "arrow-top"
										: "arrow-bottom"
								}
								size="12"
							/>
						)}
					</div>
					<div className={styles.col}>
						{product[locale].count}/{product[locale].sold}
					</div>
					<div className={styles.col}>
						{type === "Published" ? (
							<Dropdown
								className={styles.dropdown}
								classDropdownHead={styles.dropdownHead}
								value={typeSort}
								setValue={ChangeType}
								dictionary={product[locale].typesDic}
								options={types}
								small
							/>
						) : (
							product[locale].type
						)}
					</div>
					<div className={styles.col}>
						{type === "Published" ? (
							<Dropdown
								className={styles.dropdown}
								classDropdownHead={styles.dropdownHead}
								value={sorting}
								setValue={onChange}
								dictionary={product[locale].intervalsDic}
								options={intervals}
								small
							/>
						) : (
							"Status"
						)}
					</div>
					<div
						className={styles.col}
						onClick={() => sort("updatedAt")}
					>
						{product[locale].update_date}
						{filter.sortBy === "updatedAt" && (
							<Icon
								className={styles.icon_}
								name={
									filter.orderBy === "asc"
										? "arrow-top"
										: "arrow-bottom"
								}
								size="12"
							/>
						)}
					</div>
					<div className={styles.col}></div>
				</div>
				{items.map((x) => (
					<Row
						item={x}
						key={x._id}
						type={type}
						open={open}
						getNFTs_={getNFTs_}
						set_edit={set_edit}
						closeC={closeC}
					/>
				))}
			</div>
			{!isLoading && items.length === 0 && <Empty />}
			{isLoading && <Loader className={styles.loader} />}
			<div className={styles.foot}>
				<Pager {...rest} />
			</div>
		</div>
	);
};

export default Table;
